<template>

  <ion-page>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title class="ion-text-center" size="large">
          <img :src="`${publicPath}img/logo.png`" alt="Logo Ayuntamiento de Jerez" class="escudo">
          <span>Jerez Actúa</span>
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true" class="ion-padding">
      <div class="wrapper">
        <ion-card button color="secondary" @click="goView('create')">
          <ion-card-content class="ion-text-center">
            <ion-icon :icon="enterOutline" class="my-icon"></ion-icon>
          </ion-card-content>
          <ion-card-header>
            <ion-card-title class="ion-text-center">Entrar</ion-card-title>
          </ion-card-header>
        </ion-card>

        <ion-card button color="warning" @click="goView('help')">
          <ion-card-content class="ion-text-center">
            <ion-icon :icon="helpOutline" class="my-icon"></ion-icon>
          </ion-card-content>
          <ion-card-header>
            <ion-card-title class="ion-text-center">Ayuda</ion-card-title>
          </ion-card-header>
        </ion-card>
      </div>
    </ion-content>
    <ion-footer>
      <ion-toolbar color="primary">
        <ion-title class="ion-text-center" size="small">Aviso de incidencias</ion-title>
      </ion-toolbar>
    </ion-footer>
  </ion-page>

</template>

<script lang="ts" setup>

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import {
  IonPage, IonHeader, IonFooter, IonToolbar, IonContent, IonTitle, IonIcon, IonCard, IonCardHeader,
  IonCardTitle, IonCardContent, onIonViewWillEnter, onIonViewDidLeave
} from '@ionic/vue'
import { enterOutline, helpOutline } from 'ionicons/icons'
import { App } from '@capacitor/app'
import { Toast } from '@capacitor/toast'

const publicPath = process.env.BASE_URL

const MAX_BACK = 2
const router = useRouter()
const back = ref<number>(0)

const goView = (name: string) => {
  router.push({ name })
}

const showToast = async () => {
  await Toast.show({
    text: 'Pulse otra vez para cerrar la app',
  });
};

watch(back, async val => {
  if (val === MAX_BACK)
    await App.exitApp()
  else if (val === MAX_BACK - 1)
    await showToast()
})

onIonViewWillEnter(() => {
  back.value = 0
  App.addListener('backButton', () => {
    back.value++
  })
})

onIonViewDidLeave(() => {
  App.removeAllListeners()
})

</script>

<style lang="scss" scoped>

  ion-header {
    ion-title {
      font-size: 2rem;

      .escudo {
        max-height: 40px;
        width: auto;
        vertical-align: bottom;
        float: left;
      }

      span {
        display: block;
        padding-top: 2px;
      }
    }
  }

  ion-content {
    --background: none;
    background: #fff url('../../public/img/home-bg.png') no-repeat center center / cover;
  }

  ion-footer {
    ion-toolbar {
      --min-height: 35px;
    }

    ion-title {
      font-size: 1.1rem;
    }
  }

  .wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    @media screen and (orientation: landscape) {
      flex-direction: row;
      align-items: center;
    }
  }

  ion-card {
    @media screen and (orientation: landscape) {
      min-width: 30%;
    }
    ion-icon {
      font-size: 6.5rem;
    }

    ion-card-title {
      font-size: 2rem;
    }
  }

</style>
